var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("fragment", [
    _c("div", { staticClass: "emd-card-grid__column" }, [
      _c("p", { staticClass: "emd-text _color_subtle _type_caption eu-mb_1" }, [
        _vm._v(" " + _vm._s(_vm.createdAt.title) + " "),
      ]),
      _c("p", { staticClass: "emd-card-grid__line" }, [
        _vm._v(
          " " +
            _vm._s(_vm._f("dateFormat")(_vm.createdAt.date, "dateAndHour")) +
            " "
        ),
      ]),
    ]),
    _c("div", { staticClass: "emd-card-grid__column" }, [
      _c("p", { staticClass: "emd-text _color_subtle _type_caption eu-mb_1" }, [
        _vm._v(" " + _vm._s(_vm.updatedAt.title) + " "),
      ]),
      _c("p", { staticClass: "emd-card-grid__line" }, [
        _vm._v(
          " " +
            _vm._s(_vm._f("dateFormat")(_vm.updatedAt.date, "dateAndHour")) +
            " "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }